import React, { useEffect, useState, useMemo } from 'react';
import { Card } from 'primereact/card';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { Divider } from 'primereact/divider';
import { ImovelType, PropriedadesResumoType } from '../../db/Orm';
import API from '../../api/API';
import { NavigateFunction } from 'react-router-dom';

interface PropertySummaryWidgetProps {
    propriedades: ImovelType[]|undefined;
    navigate: NavigateFunction
}

const PropertySummaryWidget: React.FC<PropertySummaryWidgetProps> = ({ propriedades, navigate }) => {
    const [resumo, setResumo] = useState<PropriedadesResumoType>()
    const [totalLotes, setTotalLotes] = useState<string>('0');
    const [totalAreaHa, setTotalAreaHa] = useState<string>('0');
    const [calculating, setCalculating] = useState<boolean>(true);
    const [totalLoteAreaHa, setTotalLoteAreaHa] = useState<string>('0');
    const [isRefreshing, setIsRefreshing] = useState<boolean>(true);
    const [minimized, setMinimized] = useState<boolean>(false);
    const [chartData, setChartData] = useState({});
    const [position, setPosition] = useState({ x: window.innerWidth - 360, y: 10 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    useEffect(()=>{
        refreshResumo()
    }, [])

    const refreshResumo = ()=>{
        setIsRefreshing(true)
        setCalculating(true)
        API.getPropriedadesResumo(navigate, console.error).then(setResumo);
    }

    const chartLabels = useMemo(() => {
        if (!resumo) return [];
        const areaCultivadaHa = resumo.area_cultivada / 10000;
        const areaTotalHa = resumo.area_total / 10000;
        const percentualCultivada = areaTotalHa > 0 ? (areaCultivadaHa / areaTotalHa) * 100 : 0;
        const percentualRestante = 100 - percentualCultivada;
        return [
            `Área de Produção (${areaCultivadaHa.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ha - ${percentualCultivada.toFixed(1)}%)`,
            `Outras Áreas (${(areaTotalHa - areaCultivadaHa).toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ha - ${percentualRestante.toFixed(1)}%)`
        ];
    }, [resumo]);

    const chartDataset = useMemo(() => {
        if (!resumo) return [];
        const areaCultivadaHa = resumo.area_cultivada / 10000;
        const areaTotalHa = resumo.area_total / 10000;
        return [areaCultivadaHa, Math.max(0, areaTotalHa - areaCultivadaHa)];
    }, [resumo]);

    useEffect(()=>{
        if (resumo === undefined){
            setIsRefreshing(true)
            setCalculating(true)
            return
        }
        setTotalAreaHa(resumo.area_total.toLocaleString('pt-BR', { maximumFractionDigits: 0 }))
        setTotalLoteAreaHa(resumo.area_cultivada.toLocaleString('pt-BR', { maximumFractionDigits: 0 }))
        setTotalLotes(resumo.lotes_numero.toLocaleString('pt-BR', { maximumFractionDigits: 0 }))
        setIsRefreshing(false)
        setCalculating(false)
        setChartData({
            labels: chartLabels,
            datasets: [{
                label: 'Área',
                data: chartDataset,
                backgroundColor: ['#4CAF50', '#CCCCCC'],
                hoverBackgroundColor: ['#66BB6A', '#E0E0E0']
            }]
        })
    }, [resumo])


    // const userPropriedades = useMemo(() => {
    //     if (!propriedades)
    //         return null
    //     return propriedades.filter(prop => prop.status === STATUS.APROVADO);
    // }, [propriedades]);

    // const totalLotes = useMemo(() => {
    //     if (!userPropriedades) {
    //         return 0;
    //     }
    //     return userPropriedades.reduce((acc, prop) => acc + (prop.lotes ? prop.lotes.length : 0), 0);
    // }, [userPropriedades]);

    // const calculateAreas = useCallback(async () => {
    //     if (userPropriedades?.length === 0) {
    //         setTotalAreaHa('0');
    //         setTotalLoteAreaHa('0');
    //         setCalculating(false);
    //         setIsRefreshing(false);
    //         return;
    //     }

    //     setCalculating(true);
    //     setIsRefreshing(true);
    //     if (!userPropriedades) return

    //     const areaPromises = userPropriedades.map(async (prop: any) => {
    //         let propArea = 0;
    //         let lotesArea = 0;

    //         if (prop.poligono) {
    //             try {
    //                 const featureGroup = await mapas.carregarZipFromURL(prop.poligono);
    //                 featureGroup.eachLayer((layer: L.Layer) => {
    //                     propArea += mapas.area(layer);
    //                 });
    //             } catch (e) {
    //                 console.error(`Erro ao carregar ou processar polígono da propriedade ${prop.id || prop.nome}:`, e);
    //             }
    //         }

    //         if (prop.lotes && prop.lotes.length > 0) {
    //             const loteAreaPromises = prop.lotes.map(async (lote: any) => {
    //                 if (lote.poligono) {
    //                     try {
    //                         const featureGroup = await mapas.carregarZipFromURL(lote.poligono);
    //                         let currentLoteArea = 0;
    //                         featureGroup.eachLayer((layer: L.Layer) => {
    //                             currentLoteArea += mapas.area(layer);
    //                         });
    //                         return currentLoteArea;
    //                     } catch (e) {
    //                         console.error(`Erro ao carregar polígono do lote ${lote.id} da propriedade ${prop.id || prop.nome}:`, e);
    //                         return 0;
    //                     }
    //                 }
    //                 return 0;
    //             });
    //             const loteAreas = await Promise.all(loteAreaPromises);
    //             lotesArea = loteAreas.reduce((acc, area) => acc + area, 0);
    //         }
    //         return { propArea, lotesArea };
    //     });

    //     const results = await Promise.all(areaPromises);
    //     const totalPropAreaM2 = results.reduce((acc, res) => acc + res.propArea, 0);
    //     const totalLotesAreaM2 = results.reduce((acc, res) => acc + res.lotesArea, 0);

    //     setTotalAreaHa((totalPropAreaM2 / 10000).toLocaleString('pt-BR', { maximumFractionDigits: 0 }));
    //     setTotalLoteAreaHa((totalLotesAreaM2 / 10000).toLocaleString('pt-BR', { maximumFractionDigits: 0 }));
    //     setCalculating(false);
    //     setIsRefreshing(false);
    //     if (totalPropAreaM2 > 0) {
    //         const totalLotesHa = totalLotesAreaM2 / 10000;
    //         const totalPropHa = totalPropAreaM2 / 10000;
    //         const areaRestanteHa = Math.max(0, totalPropHa - totalLotesHa);

    //         const percentualLotes = (totalLotesHa / totalPropHa) * 100;
    //         const percentualRestante = 100 - percentualLotes;

    //         const data = {
    //             labels: [`Área de Produção (${totalLotesHa.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ha - ${percentualLotes.toFixed(1)}%)`, `Outras Áreas (${areaRestanteHa.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ha - ${percentualRestante.toFixed(1)}%)`],
    //             datasets: [
    //                 {
    //                     data: [totalLotesHa, areaRestanteHa],
    //                     backgroundColor: [
    //                         '#4CAF50',
    //                         '#CCCCCC'
    //                     ],
    //                     hoverBackgroundColor: [
    //                         '#66BB6A',
    //                         '#E0E0E0'
    //                     ]
    //                 }
    //             ]
    //         };
    //         setChartData(data);
    //     } else {
    //         setChartData({});
    //     }

    // }, [userPropriedades]);

    // useEffect(() => {
    //     calculateAreas();
    // }, [calculateAreas]);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        setIsDragging(true);
        setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (isDragging) {
            setPosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y,
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const toggleMinimized = () => {
        setMinimized(!minimized);
    };

    const chartOptions = {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    color: 'var(--text-color-secondary)'
                },
                position: 'bottom'
            }
        }
    };

    const chartDiv = useMemo(()=>
        <div className="card flex justify-content-center" style={{ marginTop: '15px' }}>
            {Object.keys(chartData).length > 0 ? (
                <Chart type="pie" data={chartData} options={chartOptions} style={{ position: 'relative', width: '100%' }} />
            ) : (
                <div style={{ textAlign: 'center', fontSize: '0.9em', color: 'var(--text-color-secondary)' }}>
                    Não há dados para exibir o gráfico.
                </div>
            )}
        </div>,
    [chartData])

    const title = (
        <div
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: isDragging ? 'grabbing' : 'grab' }}
        >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Resumo das Propriedades</span>
                <h5 style={{ fontSize: 12, marginTop: -0 }}>Dados ADAB</h5>
            </div>
            {/* <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                <span>Resumo das Propriedades</span>
            </div> */}
            <Button
                icon="pi pi-refresh"
                className="p-button-rounded p-button-text"
                tooltip="Atualizar dados"
                tooltipOptions={{ position: 'left' }}
                onClick={refreshResumo}
                loading={isRefreshing}
            />
            <Button
                icon={minimized ? "pi pi-window-maximize" : "pi pi-window-minimize"}
                className="p-button-rounded p-button-text"
                tooltip={minimized ? "Expandir" : "Minimizar"}
                tooltipOptions={{ position: 'left' }}
                onClick={toggleMinimized}
            />
        </div>
    );

    return (
        <Card title={title}
            // className="weather-widget"
            style={{ width: '300px', position: 'absolute', top: `${position.y}px`, left: `${position.x}px`, zIndex: 1000, ...minimized && { height: 120 } }}>
            {/* <Card
        //     header={title}
        //     style={{ width: '290px', minWidth: '250px', position: 'absolute', top: `${position.y}px`, left: `${position.x}px`, zIndex: 1000 }}
        // >*/}
            {!minimized && (
                <>
                    {calculating ? (
                        <div style={{ textAlign: 'center', padding: '10px 0' }}>
                            <p style={{ margin: '0 0 10px 0' }}>Calculando área...</p>
                            <ProgressBar mode="indeterminate" style={{ height: '4px' }} />
                        </div>
                    ) : (
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '5px 0' }}>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#555555' }}>
                                        {resumo?.propriedades_numero.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) || '0'}
                                    </div>
                                    <div style={{ fontSize: '0.9em', color: 'var(--text-color-secondary)' }}>
                                        Propriedades
                                    </div>
                                </div>
                                <Divider layout="vertical" />
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#555555' }}>
                                        {totalAreaHa}
                                    </div>
                                    <div style={{ fontSize: '0.9em', color: 'var(--text-color-secondary)' }}>
                                        Área Total (ha)
                                    </div>
                                </div>
                            </div>
                            <Divider />
                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '5px 0' }}>

                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#4CAF50' }}>
                                        {totalLotes}
                                    </div>
                                    <div style={{ fontSize: '0.9em', color: 'var(--text-color-secondary)' }}>
                                        Quantidade de Lotes
                                    </div>
                                </div>
                                <Divider layout="vertical" />
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#4CAF50' }}>
                                        {totalLoteAreaHa}
                                    </div>
                                    <div style={{ fontSize: '0.9em', color: 'var(--text-color-secondary)' }}>
                                        {'Área de Produção (ha)'}
                                    </div>
                                </div>
                            </div>
                            <Divider />
                            {chartDiv}
                        </div>
                    )}
                </>
            )}
        </Card>
    );
};

export default React.memo(PropertySummaryWidget);